import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { Facility } from '../../../facilities/facility'
import { BehaviorSubject } from 'rxjs'
import { AsyncPipe } from '@angular/common'
import { WorkCenterBrowserComponent } from '../work-center-browser/work-center-browser.component'
import { FacilityContextDirective } from '../../../context/facility-context/facility-context.directive'
import { FacilityContextMenuComponent } from '../../../context/facility-context/facility-context-menu/facility-context-menu.component'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderToolbarColumnDirective,
} from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-work-center-browser-viewer',
  templateUrl: './work-center-browser-viewer.component.html',
  styleUrls: ['./work-center-browser-viewer.component.scss'],
  imports: [
    ElderToolbarColumnDirective,
    FacilityContextMenuComponent,
    FacilityContextDirective,
    WorkCenterBrowserComponent,
    AsyncPipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class WorkCenterBrowserViewerComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public facility$ = new BehaviorSubject<Facility>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set facility(facility: Facility) {
    this.facility$.next(facility)
  }
}
